/** @jsx jsx */
import PaidGrantPatternDomain from 'domain/master/labor/paidGrantPattern';
import { useMemo, useState, useCallback } from 'react';
import { css, jsx } from '@emotion/core';
import { Link, useHistory } from 'react-router-dom';
import {SubActionButton} from 'components/atoms/Button';
import DataTable from 'components/organismos/DataTable/DataTable';
import { Column } from 'react-table';
import { deleteById } from 'api/paidGrantPattern';
import useToastNotification from 'hooks/useToastNotification';
import usePaidGrantList from './hooks';
import SidebarTemplate from 'components/templates/SidebarTemplate';
import FormContents from 'components/atoms/Form/FormContents';
import FormPadding from 'components/atoms/Form/FormPadding';
import FlexBoxItem from 'components/atoms/FlexBoxItem';
import IconLabelButton from 'components/molecules/IconLabelButton';
import FlexBox from 'components/atoms/FlexBox';
import Modal from 'components/molecules/Modal';
import { grayScale, textFontSize } from 'components/styles';
import BlockUI from 'components/molecules/BlockUi';
import FormHeader from 'components/templates/FormHeader';

const PaidGrantPatternPage = () => {
  const { paintGrant, setpaintGrant, isLoading, setLoading } = usePaidGrantList();
  
  const [confirmModel, setConfirmModel] = useState(false);
  const [selectedPaidGrant, setselectedPaidGrant] = useState(
    PaidGrantPatternDomain.generateInitial(),
  );
  const { successNotification, errorNotification } = useToastNotification();
  const history = useHistory();
  const closeConfirmModel = useCallback(
    () => {
      setConfirmModel(false);
    },
    [],
  );
  const openConfirmModal = useCallback(
    (a:PaidGrantPatternDomain) => {
      setConfirmModel(true);
      setselectedPaidGrant(a);
    },
    [],
  );

  const deletePaidGrantpattern = useCallback(
    () => {
      const companyCode = sessionStorage.getItem('loginUser.companyCode') || '';
      setLoading(true);
      deleteById(companyCode, selectedPaidGrant.paidHolidayPatternId).then((Response: any) => {
        setpaintGrant(paintGrant.filter((a) => a.paidHolidayPatternId
                                              !== selectedPaidGrant.paidHolidayPatternId));
        setLoading(false);
        setConfirmModel(false);
        successNotification('削除しました。');
      }).catch((error) => {
        setLoading(false);
        setConfirmModel(false);
        if (error.response && error.response.data && error.response.data.errors) {
          let msgError = '';
          error.response.data.errors.map((item: { defaultMessage: string; }) => {
            msgError += `${item.defaultMessage} \n`;
            return msgError;
          });
          errorNotification(msgError);
        } else {
          errorNotification('サーバー側でエラーが発生しました。');
        }
      });
    },
    [errorNotification, paintGrant, selectedPaidGrant.paidHolidayPatternId,
      setpaintGrant, successNotification, setLoading],
  );
  const columns: Array<Column<PaidGrantPatternDomain>> = useMemo(() => [
    {
      Header: () => null,
      id: 'actionButton',
      disableSortBy: true,
      Cell: (cell: { row :{ isExpanded: boolean, original: PaidGrantPatternDomain },
        data: Array<PaidGrantPatternDomain>
      }) => {
        return (
          <FlexBox>
            <FlexBoxItem width="36px" marginLeft="5px">
              <Link to={`/masterPaidHolidayPattern/edit/${cell.row.original.paidHolidayPatternId}`}>
                <SubActionButton action={0} onClick={() => {}} text="編集" />
              </Link>
            </FlexBoxItem>
            <FlexBoxItem margin="0 5px" width="36px">
              <SubActionButton action={1} text="削除"  onClick={() => {openConfirmModal(cell.row.original)}} />
            </FlexBoxItem>
          </FlexBox>
        );
      },
    },
    {
      Header: 'パターンコード',
      accessor: 'paidHolidayPatternCode',
    },
    {
      Header: 'パターン名',
      accessor: 'paidHolidayPatternName',
    },
  ], [openConfirmModal]);

  return (
      <SidebarTemplate>
        <BlockUI blocking={isLoading}>
        <FormHeader title="有給付与パターンマスタ" />
        <FormContents customStyle={css({marginTop:'60px'})}>
          <FormPadding customStyle={css({paddingLeft:'8px'})}>
              {/* <Link to="/masterPaidHolidayPattern/add"> */}
            <IconLabelButton onClick={() => history.push("/masterPaidHolidayPattern/add")} iconType="addCircle" text="追加" width="auto" />
              {/* </Link> */}
          </FormPadding>
          <Modal
            typeSubmit='reject'
            open={confirmModel}
            closeHandler={closeConfirmModel}
            submitText="削除する"
            title="有給付与パターンマスタを削除"
            onSubmit={deletePaidGrantpattern}
          >
            <div style={{ textAlign: 'center', color: grayScale.gray60, fontSize: textFontSize.re }}>
              有給付与パターンマスタを削除します。よろしいですか？
            </div>
          </Modal>
          <div
            css={css`
              table th:nth-of-type(1) {
                width: 84px;
              }
            `}
          >
            <div 
              className="table-bordered table-padding" 
              style={{ overflowX: 'auto', whiteSpace: 'nowrap', paddingBottom: '15px' }}
            >
              <DataTable
                className="table-no-border-left-right"
                classNameParrant="border-left-right"
                minWidth="100%" 
                columns={columns} 
                data={paintGrant} 
                isGlobalFilter={true} 
                searchRight={false} 
              />
            </div>
          </div>
        </FormContents>
      </BlockUI>
    </SidebarTemplate>
  );
};

export default PaidGrantPatternPage;
